/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Landing_Subscribetitle1Inputs */

const en_welcome_landing_subscribetitle1 = /** @type {(inputs: Welcome_Landing_Subscribetitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe digitally`)
};

/**
* | output |
* | --- |
* | "Subscribe digitally" |
*
* @param {Welcome_Landing_Subscribetitle1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const welcome_landing_subscribetitle1 = /** @type {((inputs?: Welcome_Landing_Subscribetitle1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Landing_Subscribetitle1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_welcome_landing_subscribetitle1(inputs)
});
export { welcome_landing_subscribetitle1 as "welcome_landing_subscribeTitle" }